import { lazy } from 'react';

const FinanceDashboard = lazy(() => import('../../pages/Finance/FinanceDashboard'));

export const financeRoutes = [
    {
        path: '/finance',
        element: <FinanceDashboard />,
    },
];
